var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63734 4.41594L0.997523 3.18845C0.139752 1.54282 1.79109 -0.282267 3.51405 0.407143L9.80865 2.92581C11.3257 3.53282 11.5141 5.60424 10.1315 6.47501L4.14097 10.2479C2.57695 11.2329 0.628228 9.75096 1.15955 7.98061L1.7794 5.91529C1.92922 5.41609 1.87825 4.87812 1.63734 4.41594Z",
    fill: "#F45DD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkVector);
export default __webpack_public_path__ + "static/media/pink-vector.b95c7f069bb77947d4f50bd3f3bd0afa.svg";
export { ForwardRef as ReactComponent };